import React from "react";
import * as FaIcons from "react-icons/fa";
import { FiInstagram, FiMapPin, FiPhone } from "react-icons/fi";
import styles from "../styles/contatos.module.css";

const Contatos: React.FC = () => {
  return (
    <div className={styles.pageContatos}>
      <div className={styles.tituloContatos}>
        <h1>Contatos e Redes Sociais</h1>
        <p className={styles.chamadaContatos}>
          Descubra como o <strong>Vet Viajante</strong> pode transformar a saúde
          e o bem-estar do seu pet. Conheça nosso trabalho!
        </p>
      </div>

      <div className={styles.contactInfo}>
        <div className={styles.infoBlock}>
          <FiMapPin size={50} color="#000000" />
          <h3>
            <strong>Endereço</strong>
          </h3>
          <p>
            Rua Antônio de Faria, 348, <br />
            Residencial Morumbi, Uberaba-MG
          </p>
        </div>

        <div className={styles.infoBlock}>
          <FiPhone size={48} color="#000000" />
          <h3>
            <strong>Fale conosco</strong>
          </h3>
          <p>(34) 9102-6420</p>
        </div>

        <div className={styles.infoBlock}>
          <a
            id={styles.instagram}
            href="https://www.instagram.com/vet_viajante/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FiInstagram size={50} color="#000000" />
            <h3>
              <strong>Siga-nos no Instagram</strong>
            </h3>
          </a>
        </div>

        <div className={styles.infoBlock}>
          <a
            id={styles.tiktok}
            href="https://www.tiktok.com/@vetviajante"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaIcons.FaTiktok size={50} color="#000000" />
            <h3>
              <strong>Curta nossa página no Tiktok</strong>
            </h3>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contatos;
